import axios from 'axios'

export const request = axios.create({
  baseURL: process.env.REACT_APP_API_HOST,
})

request.interceptors.response.use((response) => {
  const { data } = response

  // 刮平 Nested Data
  if (data?.data) {
    response.data = data.data
  }

  return response;
}, (error) => {
  return Promise.reject(error);
});
